export default __webpack_public_path__ + "547e06884dade4afd55bef085b75af2c.png";